import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import api from 'src/services/graphicsApi';
import { REQUEST_MOS_RESYNC_PLAYLIST } from '../reducers/mos';
import { NOTIFY } from '../reducers/notification';

function* mosResyncPlaylist(action: PayloadAction<{ mosId: string; roId: string }>) {
  try {
    const { mosId, roId } = action.payload;
    yield call(api.post, `/mos/rundown/sync`, { mosId, roId });
  } catch (error) {
    const apiError = error as Error;
    yield put({
      type: NOTIFY,
      payload: {
        variant: 'error',
        title: apiError.name,
        description: apiError.message,
      },
    });
  }
}

export default function* root() {
  yield takeLatest(REQUEST_MOS_RESYNC_PLAYLIST, mosResyncPlaylist);
}
